export default function (app) {
    app.constant('userInRole', {
        verify(currentUserRoles, requiredRoles) {
            if (!currentUserRoles ||
                !requiredRoles) {
                return false;
            }

            let found = false;

            for (const role in requiredRoles) {
                if (currentUserRoles.indexOf(requiredRoles[role]) >= 0) {
                    found = true;
                    break;
                }
            }

            return found;
        }
    });
}



// WEBPACK FOOTER //
// ./Client/app/common/constants/userInRole.js